/* Brand palette (Saudi-government green / gold) as a Vuetify 2 theme + the raw
   hex values the SVG charts need when they cannot read CSS variables. */
export const vuetifyTheme = {
  light: {
    primary: '#0d5c46', secondary: '#b68a35', accent: '#2fa07f',
    success: '#128a43', warning: '#c98a10', error: '#c9403c', info: '#2a78d6',
    anchor: '#127a5b',
  },
  dark: {
    primary: '#2fa07f', secondary: '#cda45c', accent: '#4cba8b',
    success: '#2fae77', warning: '#dfa32e', error: '#e05c52', info: '#5b9ae6',
    anchor: '#4cba8b',
  },
}

/* Chart ramps per theme (hex, because the heat-map mixes colours numerically). */
export const chartPalette = {
  light: { heat0: '#e7f2ec', green600: '#127a5b', line: '#e5eae6', ink: '#101f1a', ink2: '#43554d', ink3: '#71847b' },
  dark: { heat0: '#16241e', green600: '#2fa07f', line: '#232b27', ink: '#eef4f1', ink2: '#b6c4bd', ink3: '#83958c' },
}
export const SAT_RAMP = ['#c9403c', '#d9a81f', '#0c6e4b']
export const SERIES_COLORS = ['var(--sd-green-500)', 'var(--sd-gold-500)', 'var(--sd-blue)', 'var(--sd-violet)', 'var(--sd-pink)', 'var(--sd-aqua)']
